export default "__VITE_ASSET__CzWSn8PT__"